import React from "react";

interface NoHeaderFooterLayoutProps {
  children: React.ReactNode;
}

export const SingleLayout: React.FC<NoHeaderFooterLayoutProps> = ({
  children,
}) => {
  return <main>{children}</main>;
};
